<template>
    <div v-if="$store.state.menu.Feedback">
        <Loader :loading="loading"/>
        <v-layout wrap>
            <!--User list-->
            <v-flex v-show="!mobile || !$route.query.dealer_id"
                    class="chat-container"
                    sm12 xs12 md4 lg3>


                <div class="chat-container-list">


                    <div class="info-profile">

                        <v-text-field
                                v-model="searchQuery"
                                append-icon="mdi-magnify"
                                label="Номер телефона..."
                                class="pl-4 pr-3 mt-0 mb-0"
                                single-line
                                hide-details
                                clearable="true"
                        ></v-text-field>

                    </div>

                    <div class="chat-container-list-content">

                        <div v-for="dealer in resultQuery" :key="dealer.id" class="chat-container-list-content-item">

                            <router-link :to="{ path: 'feedback', query: { dealer_id: dealer.id }}">

                                <div class="chat-container-list-content-item-title">
                                    {{dealer.title}}
                                </div>

                                <div class="chat-container-list-content-item-phone">
                                    {{dealer.phone_number}}
                                </div>

                                <div v-if="dealer.new_messages_count"
                                     class="chat-container-list-content-item-count">
                                    {{dealer.new_messages_count}}
                                </div>

                            </router-link>

                        </div>

                    </div>

                </div>
            </v-flex>
            <!--End User list-->
            <!--Messages-->
            <v-flex v-show="$route.query.dealer_id" sm7 xs12 sm12 md8 lg9 class="chat-container">


                <div class="chat-container-message ">

                    <div class="info-profile">
                        <button @click="$router.go(-1)" v-show="mobile" class="left">
                            <v-icon>mdi-backspace</v-icon>
                        </button>
                        <button @click="SET_USER($route.query.dealer_id)"
                                class="right">
                            <v-icon>mdi-account-alert</v-icon>
                        </button>
                    </div>

                    <div v-if="dealerCard">


                        <Loader v-if="loaded" :loading="loaded" :absolute="true"/>
                        <div>
                            <div class="chat-container-message-content" ref="messageDisplay">
                                <div v-for="message in messages"
                                     :key="message.id"
                                     class="chat-container-message-content-item">
                                    <div :class="`chat-container-message-content-item-content ${(!message.is_you) ? 'right' : ''}
                        ${(message.type=='image') ? 'img' : ''}`">
                                        <div class="chat-container-message-content-item-content-name">

                                            <span class="text-danger" @click="SET_USER(message.dealer_id)"
                                                  v-if="message.is_you && dealerCard.title">
                                                {{dealerCard.title}}
                                            </span>
                                            <span v-else class="text-gray">Вы</span>
                                        </div>
                                        <div v-if="message.type=='text'"
                                             class="chat-container-message-content-item-content-value">
                                            {{message.value}}
                                        </div>
                                        <div v-else-if="message.type=='image'"
                                             class="chat-container-message-content-item-content-value image">
                                            <img @click="openImage(message.image)" :src="message.image_medium"
                                                 :alt="message.image_medium">
                                        </div>
                                        <div class="chat-container-message-content-item-content-time">
                                            <span v-if="message.time">{{message.time | dateTime}}</span>
                                            <span v-else>Отправка ...</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="chat-container-message-control">
                                <v-layout row wrap name="d">

                                    <v-flex xs8 lg10>
                                        <input v-model="msg"
                                               type="text"
                                               ref="inputMessage"
                                               v-on:keyup.enter="sendMessage"
                                               class="chat-container-message-control-text"
                                               placeholder="Сообщение..."
                                               maxlength="512">
                                    </v-flex>

                                    <v-flex xs2 lg1>
                                        <!--<button v-if="0" title="Загрузить изображение"-->
                                        <!--class="chat-container-message-control-image">-->
                                        <!--<img src="../../dist/img/attach.png" alt="Выберете изображение">-->
                                        <!--</button>-->
                                    </v-flex>

                                    <v-flex xs2 lg1>
                                        <button @click="sendMessage" title="Отправить сообщение"
                                                class="chat-container-message-control-send">
                                            <img src="/img/send.png" alt="Выберете изображение">
                                        </button>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </div>
                    </div>
                </div>
            </v-flex>
            <!--End Messages-->
        </v-layout>
        <v-dialog
                v-model="dialog"
                v-if="image"
                width="80%">
            <v-card>
                <v-card-text class="text-xs-center chat-image">
                    <img class="chat-image-zoom"
                         :src="image">
                </v-card-text>
                <v-divider>
                </v-divider>
                <v-card-actions text-right>
                    <v-btn color="primary"
                           text
                           @click="closePurchase">Закрыть
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <Dealer/>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Loader from "../components/helper/Loader";
    import Dealer from "../components/core/Dealer";
    import {mapMutations, mapState} from 'vuex';

    export default {
        components: {Dealer, Loader},
        data() {
            return {
                searchQuery: null,
                msg: '',
                dealer_id: null,
                dealers: [],
                messages: [],
                channel: null,
                loaded: true,
                loading: true,
                dialog: false,
                image: '',

                mobile: window.innerWidth <= 959,
            }
        },
        methods: {
            ...mapMutations(['SET_USER', 'SET_BADGE_MESSAGES']),
            async listDealers() {
                await axios.get('admin/chat/dealers').then(response => {

                    this.dealers = response.data.dealers;

                    this.sortDealers();

                    if (this.$route.query.dealer_id) {
                        setTimeout(() => {
                            this.dealer_id = this.$route.query.dealer_id;
                        }, 200);
                    }

                    this.loading = false;

                }).catch(error => {

                });
            },
            async readMessage() {

                this.loaded = true;
                //if (this.channel) this.sockets.unsubscribe(this.channel);
                await axios.get('admin/chat/read/' + this.dealerCard.id, {
                    params: {
                        per_page: 100
                    }
                }).then(response => {

                    this.messages = response.data.data.slice().reverse();
                    this.clearBadge();
                    this.scrollBottom(200);
                    setTimeout(() => {
                        this.loaded = false;
                        this.dealer_id = this.$route.query.dealer_id;

                    }, 200);

                }).catch(error => {

                });
            },
            sortDealers() {

                this.dealers.sort((a, b) => (a.last_message_unix_time < b.last_message_unix_time) ? 1 : -1);


            },
            openImage(image) {
                this.dialog = true;
                this.image = image;
            },
            scrollBottom(delay) {
                setTimeout(() => {
                    let messageDisplay = this.$refs.messageDisplay;
                    messageDisplay.scrollTop = messageDisplay.scrollHeight;
                }, delay);

            },
            sendMessage() {
                if (this.msg.trim() != '') {
                    this.messages.push({
                        value: this.msg,
                        is_you: false,
                        time: false,
                        type: 'text'
                    });

                    let dataSend = {
                        value: this.msg,
                        type: 1,
                        client_unix_time: Math.floor(Date.now() / 1000)
                    };
                    this.sendServer(dataSend, this.messages.length);
                    this.scrollBottom(0);
                    this.msg = '';
                }
            },
            sendServer(dataSend, count) {
                for (let i = 0; i < this.dealers.length; i++) {
                    if (this.dealerCard.id == this.dealers[i].id) {
                        this.dealers[i].last_message_unix_time = new Date().getTime();
                    }
                }
                this.sortDealers();

                axios.post('/admin/chat/send/' + this.dealerCard.id, dataSend)
                    .then(response => {
                        this.messages[count - 1].time = response.data.time;
                        if (this.$refs.inputMessage) {
                            this.$refs.inputMessage.focus();
                        }
                    })
                    .catch((response) => {
                        alert('Сообщение не отправлено');
                    });
            },
            clearBadge() {
                let COST_COUNT = 0;
                axios.get('admin/chat/read/badge/' + this.dealerCard.id);
                for (let i = 0; i < this.dealers.length; i++) {
                    if (this.dealerCard.id == this.dealers[i].id) {
                        this.dealers[i].new_messages_count = 0;
                    } else {
                        COST_COUNT += this.dealers[i].new_messages_count;
                    }
                }
                this.SET_BADGE_MESSAGES(COST_COUNT);
            },
            closePurchase() {
                this.dialog = false;
                this.image = '';
            }
        },
        computed: {
            ...mapState(['messages_chat']),
            dealerCard: {
                get() {
                    return this.dealers.filter(x => x.id == this.dealer_id)[0];
                }
            },

            resultQuery() {
                if (this.searchQuery) {
                    return this.dealers.filter((item) => {
                        return this.searchQuery.toLowerCase().split(' ')
                            .every(v => item.phone_number.toLowerCase().includes(v))
                            ;
                    });
                } else {
                    return this.dealers;
                }
            }

        },
        watch: {
            $route() {
                this.dealer_id = this.$router.history.current.query.dealer_id;
                this.msg = '';
                if (this.$refs.inputMessage) {
                    this.$refs.inputMessage.focus();
                }
            },
            dealer_id(val) {
                if (val)
                    this.readMessage();

            },
            messages_chat(data) {
                if (data) {
                    let isNew = true;
                    if (data.dealer && data.dealer.id) {
                        for (let i = 0; i < this.dealers.length; i++) {
                            if (data.dealer.id == this.dealers[i].id) {
                                this.dealers[i].new_messages_count++;
                                this.dealers[i].last_message_unix_time = new Date().getTime();
                                isNew = false;
                            }
                        }
                        if (isNew && data.dealer.id) {
                            this.dealers.unshift(data.dealer);
                        }
                        this.sortDealers();
                    }
                    if (this.dealerCard && this.dealerCard.id == data.message.dealer_id) {
                        this.messages.push(data.message);
                        this.clearBadge();
                        this.scrollBottom(0);
                    }
                }
            }
        },
        mounted() {
            this.listDealers();
            if (this.$refs.inputMessage) {
                this.$refs.inputMessage.focus();
            }

            addEventListener('resize', () => {
                this.mobile = innerWidth <= 959;
            });

        }
    }
</script>

<style>
    .v-toolbar {
        margin-bottom: 0;
    }

    .info-profile {
        height: 52px;
        border-bottom: 1px solid #ebebeb;

        position: absolute;
        left: 0;
        top: -1px;
        z-index: 2;
        width: 100%;
        background: rgba(255, 255, 255, 0.9);
        overflow: hidden
    }


    .info-profile button {
        height: 45px;
        width: 60px;
        font-size: 20px;
        color: #666;
    }

</style>